import React from "react";
import { GroupedOption } from "../../../helpers/types/common";
import { COLORS } from "../../../styles/constants.style";
import { MuiTypography } from "../../typography/MuiTypography";

interface Props {
  value: string | number | undefined;
  options: GroupedOption[];
  placeholder?: string;
}

const GroupedSelectRenderValue: React.FC<Props> = ({
  value,
  options,
  placeholder,
}) => {
  const selected = options.find((opt) => String(opt.id) === String(value));
  if (!selected) {
    return (
      <MuiTypography variant="body3SemiBold" color={COLORS.cirrus_black5}>
        {placeholder}
      </MuiTypography>
    );
  }
  return <>{selected.name}</>;
};

export default GroupedSelectRenderValue;
